import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=f8d49190&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&lang=ts&"
export * from "./RadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=f8d49190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d49190",
  null
  
)

export default component.exports